import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Location} from '@angular/common';
import {ApiService} from '../../services/api/api.service';
import {FormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import {BaseComponent} from '../base/base.component';
import {UsersService} from '../../services/users/users.service';
import {WallitService} from '../../services/wallit/wallit.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class OurlyHeaderComponent extends BaseComponent implements OnInit, AfterViewInit {

  protected spinnerLevel = 0;
  protected myBalance;

  @Input() inTab = true;
  @Input() helpId: string;
  @Input() transparent = false;
  @Input() rightButton = '';
  @Input() cancelButton = '';
  @Input() rightIcon = '';
  @Input() title;
  @Output() editEvent: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
  @Output() cancelEvent: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

  @ViewChild('content') content;
  @ViewChild('content2') content2;

  constructor(
      private location: Location,
      apiService: ApiService,
      private thisApiService: ApiService,
      private router: Router,
      private usersService: UsersService,
      private wallitService: WallitService
  ) {
    super(apiService);
    this.inTab = this.router.url.indexOf('/tabs/tab-') >= 0;
  }

  ngOnInit() {
    this.thisApiService.spinnerSubscribe(val => this.spinnerLevel = val);
    if (!this.rightButton) {
      this.usersService.meSubscribe((me) => {
        if (me) {
          this.wallitService.monitorTransferOccurred(balances => {
            this.myBalance = balances.myBalance;
          });
        } else {
          this.myBalance = undefined;
        }
      });
    }
  }

  ngAfterViewInit() {
    document.title = 'Wallit | ' + (this.title ? this.title :
     (this.content ? this.content.nativeElement.childNodes[0].data : this.content2.nativeElement.childNodes[0].data));
  }

  editClicked() {
    this.editEvent.emit();
  }

  backClicked() {
    this.location.back();
  }

  cancelClicked() {
    this.cancelEvent.emit();
  }

  joinClicked() {
    this.router.navigate([ '/signup-username' ]);
  }

  loginClicked() {
    this.router.navigate([ '/SignIn' ]);
  }

  balanceClicked() {
    this.router.navigate([ '/tabs/tab-accounts'], { replaceUrl: true });
  }

  menuClicked() {
    this.router.navigate([ '/WallitActions' ]);
  }

}
